<template>
  <article
    v-if="hideService"
    class="notification blank-placeholder"
  />
  <article
    v-else-if="hasService"
    class="tile is-child notification service-card websites-card"
  >
    <font-awesome-icon
      :icon="backgroundIcon"
      class="card-background-icon"
    />
    <div>
      <div class="content">
        <p class="title is-size-4-touch is-uppercase">
          {{ title }}
        </p>
        <p class="subtitle">
          <text-placeholder :text="subtitle" />
        </p>
        <div class="content relative-top">
          <slot />
        </div>
      </div>
    </div>
  </article>

  <article
    v-else
    class="tile is-child notification placeholder"
  >
    <div>
      <p class="title is-size-4-touch is-uppercase">
        {{ noServiceTitle }}
      </p>
      <p class="subtitle">
        {{ $t('dashboard.service.we_can_help') }}
      </p>
      <div class="content relative-top">
        <font-awesome-icon
          icon="chevron-right"
          class="link-icon"
        />
        <router-link
          :to="{ name: 'NoService' }"
          class="account-link"
        >
          {{ $t('dashboard.service.no_service') }}
        </router-link>
      </div>
    </div>
    <font-awesome-icon
      :icon="backgroundIcon"
      class="card-background-icon"
    />
  </article>
</template>

<script>
import TextPlaceholder from '@/components/Shared/TextPlaceholder'
export default {

  name: 'DashboardPanel',
  components: {
    TextPlaceholder
  },
  props: {
    hasService: {
      type: Boolean,
      default: false
    },
    hideService: {
      type: Boolean,
      default: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    noServiceTitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    backgroundIcon: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="css" scoped>
.card-background-icon {
  opacity: 0.1;
  right: 0px;
  position: absolute;
  top: 10px;
  font-size: 250px;
}
</style>
